import { HintType } from '@shared/modules/hint/classes/HintType';

export const hintComponentKeyMap = {
  [HintType.Error]: 'isErrorHintShown',
  [HintType.Info]: 'isInfoHintShown',
  [HintType.Success]: 'isSuccessHintShown',
  [HintType.Clock]: 'isClockHintShown',
  [HintType.RedSquare]: 'isNoDataHintShown',
  [HintType.YellowSquare]: 'isLimitedDataHintShown',
  [HintType.GreenSquare]: 'isTwoYearDataHintShown',
  [HintType.GraySquare]: 'isDeleteInProgressHintShown',
};

export const hintComponentCurrentlyShownMap = {
  isErrorHintShown: false,
  isInfoHintShown: false,
  isSuccessHintShown: false,
  isClockHintShown: false,
  isNoDataHintShown: false,
  isLimitedDataHintShown: false,
  isTwoYearDataHintShown: false,
  isDeleteInProgressHintShown: false,
};
